import {EvkOption} from "@evomatik/evk-common";
import {ClasificacionDiligenciaModel} from "./clasificacion-diligencia.model";
import { EstadoTareaDocumentModel } from "./estado-tarea-document.model";
import {ExpedienteDiligenciaModel} from "./expediente-diligencia.model";
import {FirmaModel} from "./firma.model";
import {ImageDataModel} from "./image-data.model";
import { TareaDocumentoModel } from "./tarea-documento.model";

export class DiligenciaTareaModel{
    id: string;
    nombreDiligencia: string;
    procedencia: string;
    idDiligenciaConfig: string;
    diligenciasConfig: string;
    tipo: string;
    clasificacion: ClasificacionDiligenciaModel;
    esDiligenciaAsociada: boolean;
    expediente: ExpedienteDiligenciaModel;
    nombreCompletoCreacion: string;
    postFijo: string;
    adicionalFormData: any;
    firma:FirmaModel;
    folio: string;
    diligenciasAsociadas: string[];
    imageData: ImageDataModel[];
    idDiligenciaPadre: string;
    idEvento: string;
    tipoEvento: string;
    tarea: TareaDocumentoModel;
    estadoTareaActivo: EstadoTareaDocumentModel;

    heredoNarativa: boolean;
    esDiligenciaRespuesta: boolean;
    fechaEnvio: Date;

    unidadDestino: EvkOption;
    unidadOrigen: EvkOption;
    usuarioDestino: EvkOption;
    usuarioOrigen: EvkOption;
    motivoEstado: string;
    numeroExpedienteMasc: string;
    idExpedienteMasc: number;
    finalizaExpediente: boolean;
    esDiligenciaIo: boolean;
    idDiligenciaBase: string;
    fromTurnador: boolean;
    mantenerFolio: boolean;
    categoriaOrganizacion: EvkOption;
    createdBy: string;
    updatedBy: string;
}
